export const formatPage = (text) => {
  if (!text) return ""; // Eğer text 'undefined' veya boşsa, boş bir string döneriz.
  return text
    .toLowerCase() // Küçük harfe çevirir
    .replace(/[^a-z0-9\s-]/g, "") // Özel karakterleri kaldırır (sadece harf, rakam, boşluk ve tire bırakır)
    .replace(/\s+/g, "-") // Birden fazla boşluğu tek bir tireyle değiştirir
    .replace(/^-+|-+$/g, ""); // Başta ve sondaki gereksiz tireleri kaldırır
};
